import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { IPrimaryBasicData } from '@fiverr-private/primary_section_sdk';

export const PrimaryDefault = (_props: IPrimaryBasicData) => <Container>Default Primary</Container>;
